export class Stepper {
  private stepper: JQuery<HTMLElement>;
  private activeStep?: JQuery<HTMLElement>;

  constructor(stepper: any) {
    this.stepper = $(stepper);
    const steps: JQuery<HTMLElement> = this.getSteps();
    this.activeStep = steps.first();
    steps.not(this.activeStep).hide();
  }

  get index(): number {
    return this.getSteps().index(this.activeStep);
  }

  get length(): number {
    return this.getSteps().length;
  }

  next() {
    this.changeStep(this.index + 1);
  }

  prev() {
    this.changeStep(this.index - 1);
  }

  setStep(step: number) {
    this.changeStep(step);
  }

  private getSteps(): JQuery<HTMLElement> {
    return $("> [data-step]", this.stepper);
  }

  private changeStep(index: number) {
    const steps: JQuery<HTMLElement> = this.getSteps();

    if (steps.length === 0) {
      return;
    }

    if (index < 0) {
      index = 0;
    }

    if (index >= steps.length) {
      index = steps.length - 1;
    }

    const step: HTMLElement | undefined = steps.get(index);

    this.stepper.fadeOut(200, () => {
      if (this.activeStep != null) {
        this.activeStep.hide();
      }

      if (step) {
        this.activeStep = $(step);
        this.activeStep.show().trigger("show");
        this.stepper.fadeIn(200);
      }
    });
  }
}
